module.exports = __webpack_public_path__ + "img/Header2.26dc5ab8.png";